var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-container",attrs:{"id":_vm.content.id}},[_c('b-container',[_c('b-row',[_c('b-col',[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.content.text)}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }